import { Components, Theme } from '@mui/material/styles';
import { borderRadius } from '../foundations/shape';

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  variants: [
    {
      props: { variant: 'outlined' },
      style: ({ theme }) => ({
        border: `1px solid ${theme.palette.studio.borders.subtle}`,
        backgroundColor: theme.palette.studio.surfaces.fillSubtle,
        boxShadow: theme.palette.studio.shadows.button,
        '&:hover': { backgroundColor: theme.palette.action.hover },
        '&:active': {
          transform: 'translateY(1px)',
          boxShadow: theme.palette.studio.shadows.buttonPressed,
        },
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: borderRadius.medium,
      padding: 6,
      transition: theme.transitions.create(['box-shadow', 'transform']),
    }),
    sizeSmall: {
      padding: '4px',
      borderRadius: borderRadius.small,
      '&:hover': {
        backgroundColor: 'action.hover',
      },
    },
  },
};
